// This file was automatically generated from appshared.dialog.reassignReviewUser.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.reassignReviewUser');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.reassignReviewUser.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="reassign-review-user-form"><div class="overlayContainer">', (opt_data.isBatchMode) ? '<p class="el8LargeFontSize">Re-assign all reports awaiting review for <span class="patient-name"></span> to:</p>' : '<p class="el8LargeFontSize">Re-assign report awaiting review (<span class="report-description"></span>) to:</p>', '<div class="spacer5 user-dropdown-box"></div>', (opt_data.isBatchMode) ? '<p class="el8AppText">Note: The report' + ((opt_data.isBatchMode) ? 's' : '') + ' will be removed from your queue.</p>' : '<p class="el8AppText">Currently assigned to <span class="review-user-name"></span>.</p>', '</div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.reassignReviewUser.userDropdown = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<select name="user" class="w100">');
  var uList8755 = opt_data.users;
  var uListLen8755 = uList8755.length;
  for (var uIndex8755 = 0; uIndex8755 < uListLen8755; uIndex8755++) {
    var uData8755 = uList8755[uIndex8755];
    output.append('<option value="', soy.$$escapeHtml(uData8755.id), '">', soy.$$escapeHtml(uData8755.name), '</option>');
  }
  output.append('</select>');
  if (!opt_sb) return output.toString();
};
